import React from 'react';
import { useSelector } from 'react-redux';
import { Heading, Page } from '@zillow/constellation-10';

import UnsubscribeError from 'app/shared/components/UnsubscribeError';

import type { State } from 'app/shared/types/State';

const UnsubscribeAllPage = () => {
  const didUnsubscribeAllSucceed = useSelector((state: State) => state.marketing.didUnsubscribeAllSucceed);

  return (
    <Page.Root
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'bg.screen.neutral',
      }}
    >
      <Page.Content css={{ paddingBottom: '1500' }}>
        {didUnsubscribeAllSucceed ? (
          <>
            <Heading level={1} textStyle="heading-lg" fontFamily="heading-alt" css={{ marginTop: '800' }}>
              Thank you!
            </Heading>
            <Heading level={2} textStyle="body-lg-bold" css={{ marginTop: '600' }}>
              You&apos;ve been unsubscribed from all market update emails
            </Heading>
          </>
        ) : (
          <UnsubscribeError />
        )}
      </Page.Content>
    </Page.Root>
  );
};

export default UnsubscribeAllPage;
